import { render, staticRenderFns } from "./SportFullTable.vue?vue&type=template&id=0baff081&scoped=true&"
import script from "./SportFullTable.vue?vue&type=script&lang=js&"
export * from "./SportFullTable.vue?vue&type=script&lang=js&"
import style0 from "./SportFullTable.vue?vue&type=style&index=0&id=0baff081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baff081",
  null
  
)

component.options.__file = "SportFullTable.vue"
export default component.exports